<template>
  <div class="fondo_transparente">
    <div class="ventana_modal">
      <div class="X_cerrar" @click="cerrar">&ltrif;</div>
      <div class="ingreso">
        <div class="textoBienvenida">¡Hola, {{usuarioEnSesion.nombre}}!</div>
         <!-- <img class="previewPortada" :src="usuarioEnSesion.foto"/> -->
      </div>
      <div class="container">
          <div @click="datosPersonales"><p>Datos personales</p></div>
          <div @click="explorarColecciones"><p>Explorar colecciones</p></div>
          <div @click="verCatastro"><p>Ver catastro</p></div>
          <div @click="verDiccionario"><p>Ver diccionario</p></div>
          <div @click="irBusquedas"><p>Búsquedas</p></div>
          <div
            v-if="utilSVE" @click="irUtilidadesMiembros">
            <p>Utilidades miembros SVE</p>
          </div>
          <div
            v-if="gestBib" @click="MenuColecciones">
            <p>Gestionar colecciones</p>
          </div>
          <div
            v-if="gestUsu" @click="irGestionUsuarios">
            <p>Gestionar usuarios</p>
          </div>
          <div
            v-if="gestBib" @click="irGestionCatastro">
            <p>Gestionar catastro</p>
          </div>
          <div
            v-if="gestBib" @click="irGestionDicc">
            <p>Gestionar diccionario</p>
          </div>
          <div
            v-if="gestBib" @click="irDatosCatal">
            <p>Datos catálogo</p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Bienvenida',
  created () {
    if (this.usuarioEnSesion.nombre === undefined) {
      this.$router.push('/')
    }
    switch (this.usuarioEnSesion.tipoUsuario) {
      case 1 :
        this.utilSVE = true
        break
      case 2 :
        this.gestBib = true
        this.utilSVE = true
        break
      case 3 :
        this.gestUsu = true
        this.gestBib = true
        this.utilSVE = true
        break
    }
  },
  data () {
    return {
      utilSVE: false,
      gestBib: false,
      gestUsu: false
    }
  },
  methods: {
    cerrar () {
      this.$router.push('/')
    },
    irGestionUsuarios () {
      this.$router.push('/gestionUsuarios')
    },
    irUtilidadesMiembros () {
      this.$router.push('/utilidadesMiembros')
    },
    irBusquedas () {
      this.$router.push('/busquedas')
    },
    explorarColecciones () {
      this.$router.push('/page2')
    },
    verCatastro () {
      this.$router.push({ name: 'VistaCol', params: { nomCol: 'Catastro', showCol: 'catastro' } })
    },
    verDiccionario () {
      this.$router.push({ name: 'VistaCol', params: { nomCol: 'Diccionario', showCol: 'diccionario' } })
    },
    datosPersonales () {
      this.$router.push('/datosPersonales')
    },
    irGestionCatastro () {
      this.$router.push('/gestionCatastro')
    },
    irGestionDicc () {
      this.$router.push('/gestionDicc')
    },
    irDatosCatal () {
      this.$router.push('/datosCatalogo')
    },
    MenuColecciones () {
      this.$router.push('/menuColecciones')
    }
  },
  computed: {
    ...mapState(['usuarioEnSesion'])
  }
}
</script>

<style scoped>

.ventana_modal{
    /* background: -webkit-linear-gradient(115deg, rgb(180, 180, 180),rgb(214, 214, 214),rgb(180, 180, 180), rgb(68, 68, 68)); */
    width: 70vw;
    height: 70vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    border-radius: 5px;
    display: grid;
    /* flex-direction: column; */
    grid-template-rows: 35% 65%;
    justify-items: center;
    align-items: space-around;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    /* border:  1px solid rgb(179, 179, 179) */
}
.ingreso{
  background-color: rgba(10, 90, 140, 0.5);
  justify-self: stretch;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  /* border: solid 1px rgb(130, 238, 130); */
  display:grid
}
.textoBienvenida{
  justify-self: left;
  align-self: center;
  margin-left: 8%;
  font-size: 45px;
  font-weight: lighter;
  padding-bottom: 5px;
  color:rgb(251, 155, 82)
}
.container {
  display: grid;
  height: 100%;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  color:white;
  font-size: 1.2rem;
  font-weight: lighter;
  justify-content: center;
  align-items: auto;
  grid-gap:2px;
  margin-top: 2px;
  /* border:1px solid darkorange; */
}
.container div{
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 15px;
  background-color:rgba(10, 90, 140, 0.7);
  cursor: pointer;
  -moz-transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
.container div:hover{
  /* border-color: rgba(1, 117, 163, 0.95); */
  background-color:rgba(10, 90, 140, 0.9);
}
.container div p {
  -moz-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.container div:hover p {
  transform: translateY(-6px);
}

.X_cerrar{
  font-family: OpenL;
  font-size: 35px;
  position: absolute;
  right: 10px;
  color:white;
  top: 10px;
  padding-bottom: 2px;
  width: 35px;
  height: 35px;
  /* border-radius: 20px; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(1, 117, 163, 0);
  /* border:2px solid darkorange; */
}
.X_cerrar:hover{
  /* border-color: white; */
  /* background-color: rgb(253, 242, 205, 0.2); */
  border: solid 1px rgba(1, 117, 163, 0.4);
}
.previewPortada{
  width: 50px;
}
@media screen and (max-width: 576px){
  .ventana_modal{
    width: 80vw;
    height: 85vh;
    display: flex;
    flex-direction: column;
    /* grid-template-rows: 20% 80%; */
    /* border:  1px solid rgb(179, 179, 179) */
  }
  .ingreso{
    height: 25vh;
  }
  .textoBienvenida{
    justify-self:center;
    align-self:flex-end;
    margin-left: 0%;
    font-size: 35px;
    padding-bottom: 15px;
    font-weight: lighter;
    color:var(--na);
  }
  .container{
    display: flex;
    flex-direction: column;
    justify-content:flex-start;
    font-size: 1rem
  }
  .container div{
    padding-top: 0px;
  }
}
@media screen and (max-width: 376px){
  .textoBienvenida{
    justify-self:center;
    align-self:flex-end;
    margin-left: 0%;
    font-size: 28px;
    padding-bottom: 10px;
    font-weight: lighter;
    color:var(--na);
  }
  .container div{
    height: 6.2vh;
  }
  .container div p{
    margin: 9px;
  }
}
</style>
